// extracted by mini-css-extract-plugin
module.exports = {"input":"LogicField_input__kAFJr"};